import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddTicketCommentInput, EditTicketCommentInput, Result, ResultList, TicketCommentResult } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class TicketCommentService {

  constructor(private httpClient: HttpClient) { }

  public addTicketComment(ticketCommentInput: AddTicketCommentInput, token: string): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'TicketComment/AddTicketComment', ticketCommentInput, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }
  public updateTicketComment(editTicketCommentInput: EditTicketCommentInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'TicketComment/UpdateTicketComment', editTicketCommentInput,  Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getTicketComment(ticketId: number, token: string): Promise<ResultList<TicketCommentResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'TicketComment/GetTicketComment?ticketId=' + ticketId, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new ResultList<TicketCommentResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<TicketCommentResult>(), result.error));
  }
}